import React from "react";

export function bannerInfo(gameId) {
  if (gameId === "g66naxx2tw") {
    return <img
    src="/p/image/support_help/g66_wire_report_banner.jpg"
    className="rounded img-fluid m-auto"
    alt="千呼萬喚的儲值方案登場了!!"
    ></img>;
  } else if (gameId === "G115") {
    return <img
    src="/p/image/support_help/g115_wire_report_banner.png"
    className="rounded img-fluid m-auto"
    alt="千呼萬喚的儲值方案登場了!!"
    ></img>;
  } else if (gameId === "MA96") {
    return <img
    src="/p/image/support_help/ma96_wire_report_banner.jpg"
    className="rounded img-fluid m-auto"
    alt="親愛的冒險家，千呼萬喚的儲值方案登場了!!"
    ></img>;
  } else {
    return <img
    src="/p/image/support_help/h55_wire_report_banner.png"
    className="rounded img-fluid m-auto"
    alt="各位親愛的偵探們照過來!!"
    ></img>;
  }
};

export function sloganInfo(gameId) {
  if (gameId === "g66naxx2tw" || gameId === "G115") {
    return <h5 className="display-5">
      <span role="img" aria-label="fire">
        🔥🔥
      </span>
      千呼萬喚的儲值方案登場了!!
      <span role="img" aria-label="fire">
        🔥🔥
      </span>
    </h5>;
  } else if (gameId === "MA96") {
    return <h5 className="display-5">
      <span role="img" aria-label="prince princess">
        🤴👸
      </span>
      親愛的冒險家，千呼萬喚的儲值方案登場了!!
      <span role="img" aria-label="prince princess">
        🤴👸
      </span>
    </h5>;
  } else {
    return <h5 className="display-5">
      <span role="img" aria-label="magnifier">
        🔎 🔎
      </span>
      各位親愛的偵探們照過來
      <span role="img" aria-label="magnifier">
        🔎 🔎
      </span>
    </h5>;
  }
};

export function productsInfo(gameId, products) {
  const comma = /\B(?=(\d{3})+$)/g;  
  return <div>
      <h3 className="mt-2">方案如下 ：</h3>
      <ul>
        {products.map((prod) => (
          <li key={`prod_${prod.product_id}`}>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.{prod.price.toString().replace(comma, ',')}，共可獲得 {prod.gold.toString().replace(comma, ',')}{" "}
            {gameId === "g66naxx2tw" ? "信用點" : gameId === "G115" ? "有償海藍石" : gameId === "MA96" ? "鑽石" : "回聲"}
            {(gameId === "MA96") ? (
              <span>{` + ${prod.free_golds.toString().replace(comma, ',')} 綁鑽`}</span>              
            ) : (gameId === "G115") ? (
              <span>{` + ${prod.free_golds.toString().replace(comma, ',')} 無償海藍石`}</span>              
            ) : null}
            。
            {(gameId === "g66naxx2tw" && prod.price >= 15000) ? (
              <span role="img" aria-label="gift">
                🎁
              </span>
            ) : null}
          </li>
        ))}
      </ul>
      <br />
    </div>;
};

export function eventInfo(gameId, gift) {
  if (gameId === "g66naxx2tw" && gift) { 
    return <div className="alert alert-primary" role="alert">
        <h5 className="alert-heading"> 限時滿額禮：</h5>
        單筆購買滿NTD 15,000元以上， <br />
        {gift.items}
        <br />
        購買滿NTD 30,000元，即贈送兩包滿額禮，以此類推！
        <br />
        滿額禮僅計算<strong>單筆消費</strong>，無法累積計算或合併計算。
      </div>;
  } else if (gameId === "MA96") {
    return <div className="alert alert-primary" role="alert">
        現在全面試營運中
      </div>;
  } else {
    return null;
  }
};